import React from "react";
import { TableRow, TableCell } from "./Table";
import Text from "./Text";
import Button from "./Button";
import Link from "./Link";
import Icon from "./Icon";
import { CLEAR } from "../icons";
import * as colors from "../settings/colors";

const ALink = Link.withComponent("a");

class FranchiseStaffListRow extends React.Component {
  state = {
    inviteResent: false
  };

  reinviteUser = () => {
    this.props.reinviteUser(this.props.franchiseMembership.user).then(() => {
      this.setState({ inviteResent: true });
    });
  };

  renderInvitationLink() {
    return (
      <ALink color={colors.BLUE} onClick={this.reinviteUser}>
        Resend invite.
      </ALink>
    );
  }

  handleCheckboxChange = e => {
    const franchiseId = this.props.franchiseId;
    const { id, user } = this.props.franchiseMembership;
    this.props.updateFranchiseMembership({
      id,
      input: {
        userId: user.id,
        franchiseId,
        [e.target.name]: e.target.checked
      }
    });
  };

  render() {
    const {
      columns,
      deleteFranchiseMembership,
      franchiseMembership
    } = this.props;
    const {
      id,
      user,
      owner,
      canSubmitJobs,
      trackAsSalesperson
    } = franchiseMembership;

    return (
      <TableRow columns={columns}>
        <TableCell>
          <Text style={{ margin: 0 }}>
            {user.name && (
              <span>
                {user.name}
                <br />
              </span>
            )}
            <span style={{ color: colors.TEXT_TERTIARY }}>{user.email}</span>{" "}
            {!user.invitationTokenRedeemed &&
              (this.state.inviteResent
                ? "Invite sent!"
                : this.renderInvitationLink())}
          </Text>
        </TableCell>
        <TableCell justify="center">
          <input
            name="owner"
            type="checkbox"
            checked={owner}
            onChange={this.handleCheckboxChange}
          />
        </TableCell>
        <TableCell justify="center">
          <input
            name="canSubmitJobs"
            type="checkbox"
            checked={canSubmitJobs}
            onChange={this.handleCheckboxChange}
          />
        </TableCell>
        <TableCell justify="center">
          <input
            name="trackAsSalesperson"
            type="checkbox"
            checked={trackAsSalesperson}
            onChange={this.handleCheckboxChange}
          />
        </TableCell>
        <TableCell justify="flex-end">
          <Button
            variant="danger"
            onClick={() => deleteFranchiseMembership(franchiseMembership)}
            hasIcon
          >
            <Icon icon={CLEAR} />
          </Button>
        </TableCell>
      </TableRow>
    );
  }
}

export default FranchiseStaffListRow;



// WEBPACK FOOTER //
// ./src/components/FranchiseStaffListRow.js